import { useContext } from "react";
import { AnimatePresence, motion } from "framer-motion";
import clsx from "clsx";
import { context } from "@/Layout";
import useStore from "@/hooks/useStore";
import useUtils from "@/hooks/useUtils";
import { DESKTOP } from "@/utils/appConstants";
import { NavMenuRevampPropTypes } from "./propTypes";
import NavParentRevamp from "../NavParentRevamp/NavParentRevamp";

const NavMenuRevamp = ({ children }) => {
  const { menu } = useStore();
  const { device } = useUtils();
  const desktop = device === DESKTOP;

  const navMenu = menu({ name: "main-menu" });
  const { isOpened } = useContext(context);

  const normalizeMenu = (menu) => {
    const mainLevel = [];
    menu.forEach((element) => {
      if (element.parent === "0") {
        mainLevel.push({ el: element, children: [] });
      } else {
        const parent = mainLevel.findIndex((item) => item.el.id.toString() === element.parent);
        mainLevel[parent].children.push(element);
      }
    });

    return mainLevel;
  };

  const transition = { duration: 0.45, ease: [0.22, 0.61, 0.36, 1] };

  const backdrop = {
    hidden: { opacity: 0 },
    show: { opacity: 1, transition },
    exit: { opacity: 0, transition },
  };

  const panel = {
    hidden: { y: -8, opacity: 0 },
    show: { y: 0, opacity: 1, transition },
    exit: { y: -8, opacity: 0, transition },
  };

  return (
    <AnimatePresence mode="wait" initial={false}>
      {(isOpened || desktop) && (
        <div className="fixed inset-0 z-10 lg:static lg:z-auto isolate">
          {/* {!desktop && (
            <motion.div
              key="menu-backdrop"
              className="fixed inset-0 bg-[#0B0E13]/30 backdrop-blur-[18px] lg:hidden pointer-events-none will-change-[opacity]"
              variants={backdrop}
              style={{
                willChange: "opacity",
                WebkitTransform: "translate3d(0,0,0)",
                transform: "translate3d(0,0,0)",
              }}
              initial="hidden"
              animate="show"
              exit="exit"
            />
          )} */}

          <motion.nav
            id="main-menu"
            className={clsx(
              "absolute left-0 right-0 top-0 lg:relative",
              "flex flex-col pt-20 px-6 lg:px-0 lg:flex-row lg:gap-8 lg:pt-0 lg:justify-center"
            )}
            variants={panel}
            initial={desktop ? false : "hidden"}
            animate="show"
            exit="exit"
          >
            {normalizeMenu(navMenu).map((navItem) => (
              <NavParentRevamp key={navItem.el.id} navItem={navItem} />
            ))}
          </motion.nav>

          <div className="lg:hidden menu-item container px-0">{children}</div>
        </div>
      )}
    </AnimatePresence>
  );
};

NavMenuRevamp.propTypes = NavMenuRevampPropTypes;

export default NavMenuRevamp;
